import { Model } from '../Model.js';

var _dec, _class;

/**
 * Plain object CashOnDelivery representation.
 *
 */

/**
 * Serialized object CashOnDelivery representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

let CashOnDelivery = (_dec = Model(), _dec(_class = class CashOnDelivery {
  /**
   * Takes a ICashOnDeliveryApiResponse from Packlink's API and returns a CashOnDelivery.
   *
   * @param response  ICashOnDeliveryApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new CashOnDelivery(response.account_holder, response.amount, response.iban);
  }

  /**
   * Takes a serialized CashOnDelivery and returns a CashOnDelivery.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized CashOnDelivery.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedCashOnDelivery.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of CashOnDelivery.
   *
   */

  /**
   * Takes a serialized CashOnDelivery and returns a CashOnDelivery.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized CashOnDelivery.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedCashOnDelivery.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of CashOnDelivery.
   *
   */

  /**
   * Takes a serialized CashOnDelivery and returns a CashOnDelivery.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized CashOnDelivery.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedCashOnDelivery.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of CashOnDelivery.
   *
   */

  /**
   * Takes a serialized CashOnDelivery and returns a CashOnDelivery.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized CashOnDelivery.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedCashOnDelivery.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of CashOnDelivery.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new CashOnDelivery(data.accountHolder, data.amount, data.iban);
  }

  /**
   * Returns a new CashOnDelivery. Typings of the properties depend on the class type param T
   *
   */
  constructor(accountHolder, amount, iban) {
    this.accountHolder = accountHolder;
    this.amount = amount;
    this.iban = iban;
  }

  /**
   * Returns a JSON serialized version of the CashOnDelivery.
   *
   */
  toJSON() {
    return {
      accountHolder: this.accountHolder,
      amount: this.amount,
      iban: this.iban
    };
  }

  /**
   * Returns a clone of the CashOnDelivery.
   *
   */
  clone() {
    return new CashOnDelivery(this.accountHolder, this.amount, this.iban);
  }

  /**
   * Returns whether the two CashOnDelivery are equal.
   *
   */
  equals(cod) {
    if (!cod) {
      return false;
    }
    return this.accountHolder === cod.accountHolder && this.amount === cod.amount && this.iban === cod.iban;
  }

  /**
   * Returns a JSON with the payload necessary to create a COD if available.
   *
   */
  getCreatePayload() {
    return this.iban && this.amount && this.accountHolder ? {
      account_holder: this.accountHolder,
      amount: this.amount,
      iban: this.iban
    } : undefined;
  }
}) || _class);

export { CashOnDelivery };
//# sourceMappingURL=CashOnDelivery.js.map
